import { PropsWithChildren } from 'react';
import { Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import { FadeUpContainerProp } from '../types';

export const SelectedSnapDisplayContainer = ({
  children,
}: PropsWithChildren) => {
  return (
    <Box className="absolute bottom-6 right-6 tablet:bottom-10 tablet:right-10">
      {children}
    </Box>
  );
};

export const CarouselContainer = ({ children }: PropsWithChildren) => {
  return (
    <section className={twJoin('relative', 'desktop:max-w-[744px]')}>
      {children}
    </section>
  );
};

export const ContentInfoContainer = ({ children }: PropsWithChildren) => {
  return (
    <Box
      className={twJoin(
        'absolute bottom-[54px] left-6 pr-6',
        'tablet:bottom-10 tablet:left-10 tablet:pr-[190px]'
      )}
    >
      {children}
    </Box>
  );
};

export const FadeUpContainer = ({ enabled, children }: FadeUpContainerProp) => {
  return (
    <Box
      className={twJoin(
        'transition-all duration-500',
        enabled
          ? 'translate-y-0 opacity-100 delay-500'
          : 'translate-y-[10px] opacity-0'
      )}
    >
      {children}
    </Box>
  );
};
